<template>
    <eventi-list-component :utente="utente" :key="keyListaEventi" :titoloEvento="titoloEvento" :pathEventResource="pathEventResource" :linkEvent="linkEvent" tipoEvento="DATI CLINICI STRUMENTALI ICTUS"></eventi-list-component>
</template>

<script>
import EventiListComponent from "../../../base/components/EventiListComponent.vue";
export default {
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: {
        EventiListComponent,
    },

    watch: {
        utente: function () {
            this.keyListaEventi++;
        },
    },
    mounted() {},
    data() {
        return {
            titoloEvento: "Dati Clinico-Strumentali Ictus",
            pathEventResource: "/cardiodaticlinicistrumentaliictus",
            keyListaEventi: 0,
            linkEvent: "/paziente/cardiologia/daticlinicostrumentaliictus",
        };
    },
};
</script>

<style></style>
